<template>
  <div>
    <!-- <div class="footer">
      <div class="footer-main">
        <About />

        <div class="taiwan">
          <span>专业台矩阵</span>
          <Taiwan />
          <div>
            <span>合作伙伴</span>
            <ul class="partner-list">
              <li>
                <a>
                  <img
                    src="http://imgs-b2b.toocle.com/Public/home/images/zyt/logo/jy/zbyc.png"
                  />
                </a>
              </li>
              <li>
                <a>
                  <img
                    src="https://www.100ec.cn/Public/home/images/zyt/logo/jy/hxx.png"
                  />
                </a>
              </li>
              <li>
                <a>
                  <img
                    src="https://www.100ec.cn/Public/home/images/zyt/logo/jy/hqwx.png"
                  />
                </a>
              </li>
              <li>
                <a>
                  <img
                    src="https://www.100ec.cn/Public/home/images/zyt/logo/jy/aks.png"
                  />
                </a>
              </li>
              <li>
                <a>
                  <img
                    src="https://www.100ec.cn/Public/home/images/zyt/logo/jy/hx.png"
                  />
                </a>
              </li>
              <li>
                <a>
                  <img
                    src="https://www.100ec.cn/Public/home/images/zyt/logo/jy/daw.png"
                  />
                </a>
              </li>
              <li>
                <a>
                  <img
                    src="https://www.100ec.cn/Public/home/images/zyt/logo/jy/hhsw.png"
                  />
                </a>
              </li>
              <li>
                <a>
                  <img
                    src="https://www.100ec.cn/Public/home/images/zyt/logo/jy/sdjg.png"
                  />
                </a>
              </li>
              <li>
                <a>
                  <img
                    src="https://www.100ec.cn/Public/home/images/zyt/logo/jy/VIPKID.png"
                  />
                </a>
              </li>
              <li>
                <a>
                  <img
                    src="https://www.100ec.cn/Public/home/images/zyt/logo/jy/hxx.png"
                  />
                </a>
              </li>
              <li>
                <a>
                  <img
                    src="https://www.100ec.cn/Public/home/images/zyt/logo/jy/yfd.png"
                  />
                </a>
              </li>
              <li>
                <a>
                  <img
                    src="https://www.100ec.cn/Public/home/images/zyt/logo/jy/zyb.png"
                  />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="qrcode">
          <div class="wx-public">
            <p>微信公众号</p>
            <img :src="require('@/assets/wx-public.jpg')" />
            <p>扫码关注</p>
          </div>

          <div class="wx-private">
            <p>商务合作</p>
            <img
              src="//imgs-b2b.toocle.com/Public/home/images/o2o-private.jpg"
            />
            <p>联系陈老师</p>
          </div>
        </div>
      </div>

      <Record /> -->
    <!-- </div> -->

    <!-- <el-dialog
      class="cooperation"
      :visible.sync="$store.state.coopeShow"
      width="20%"
      center
      :show-close="false"
    >
      <h1>商务合作/媒体采访：</h1>
      <p>联系人：陈老师</p>
      <p>电话：0571-85337217</p>
      <p>手机：15168211391</p>
      <p>邮箱：O2O@netsun.com</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="$store.commit('getBusiness', false)"
          >我知道了</el-button
        >
      </span>
    </el-dialog> -->

      <div ref="footerContainer"></div>

  </div>
</template>

<script>
import { About } from "shared";
import { Taiwan } from "shared";
import { Record } from "shared";

export default {
  name: "Footer",
  components: {
    About,
    Taiwan,
    Record,
  },
   data() {
    return {
      footerContent: ''
    };
  },
 
  mounted() {
    this.loadFooter();
  },
  methods: {
    loadFooter() {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', '/Public/View/Public/footer.html', true);
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4 && xhr.status === 200) {
          let content = xhr.responseText;
          content = content.replace(/["']zt\/mgpmk\/__PJ__\/home\//g, '"/Public/home/');
          content = content.replace(/["']__PJ__\/home\//g, '"/Public/home/');
          content = content.replace(/["']\/__PJ__\/home\//g, '"/Public/home/');
          content = content.replace(/["']home\/images\//g, '"/Public/home/images/');
          content = content.replace(/["']home\/css\//g, '"/Public/home/css/');
          this.renderFooter(content);
        }
      };
      xhr.send();
    },
    renderFooter(content) {
      const container = this.$refs.footerContainer;
      const shadowRoot = container.attachShadow({ mode: 'open' });
      
      const wrapper = document.createElement('div');
      wrapper.className = 'footer-wrapper';
      wrapper.innerHTML = content;
      shadowRoot.appendChild(wrapper);

      const style = document.createElement('style');
      style.textContent = `
        :host {
          display: block;
          width: 100%;
        }
        .footer-wrapper {
          position: relative;
          width: 100%;
          margin: 0 auto;
          height: auto;
        }
        .footer-wrapper .main {
          position: relative;
          width: 1100px;
          margin: 0 auto;
          height: auto;
        }
          ul {
                padding-inline-start: 0;
            }
        a {
            text-decoration: none;
        }
          .bottom2 li {
            list-style-type: none;
        }
        @media screen and (max-width: 1100px) {
          .footer-wrapper .main {
            width: 100%;
          }
        }
          
      `;
      shadowRoot.appendChild(style);

      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = '/Public/home/css/footer.css';
      shadowRoot.appendChild(link);
    }
  }
};
</script>